export const MENU_OPTIONS = [
  {
    label: "Home",
    path: "/",
  },
  {
    label: "Dashboard",
    path: "/admin",
  },
  {
    label: "Profile",
    path: "/admin/view/profile",
  },
];
export const SUBSCRIBER_MENU_OPTIONS = [
  {
    label: "Home",
    path: "/",
  },
  {
    label: "Dashboard",
    path: "/subscriber",
  },
  {
    label: "Profile",
    path: "/subscriber/edit/profile",
  },
];
